  /*!

  =========================================================
  * Argon Dashboard React - v1.2.4
  =========================================================

  * Product Page: https://www.creative-tim.com/product/argon-dashboard-react
  * Copyright 2024 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

  * Coded by Creative Tim

  =========================================================

  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  */
  import { useState, useEffect } from "react";
  // node.js library that concatenates classes (strings)
  import classnames from "classnames";
  // javascipt plugin for creating charts
  import Chart from "chart.js";
  // react plugin used to create charts
  import { Line, Bar } from "react-chartjs-2";
  // reactstrap components
  import {
    Button,
    Card,
    CardHeader,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    Col,
    Badge,
    CardFooter,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
    Media,
    Pagination,
    PaginationItem,
    PaginationLink,
    Progress,
    Table,
    Container,
    Row,
    UncontrolledTooltip,
    Dropdown,  CardTitle,
  } from "reactstrap";

  // core components
  import {
    chartOptions,
    parseOptions,
    chartExample1,
    chartExample2,
  } from "dashboard/project-management/variables/charts.js";
  import {api} from '../../../../api'
  import Cookies from "js-cookie";

  const Budget2 = (props) => {
    const [activeNav, setActiveNav] = useState(1);
    const [chartExample1Data, setChartExample1Data] = useState("data1");
    const [selectedOption, setSelectedOption] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
  
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
  
  
  
    if (window.Chart) {
      parseOptions(Chart, chartOptions());
    }
  
    const toggleNavs = (e, index) => {
      e.preventDefault();
      setActiveNav(index);
      setChartExample1Data("data" + index);
    };
  
    const handleOptionSelectChange = (selectedOption) => {
      setSelectedOption(selectedOption);
    };
  
    let emp_id = 4;
  
  
    const [project, setproject] = useState([]);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const company_id = Cookies.get('company_id');
          const response = await api.get(`viewProjectDetails.php?s_m_id=${emp_id}&company_id=${company_id}`);
          setproject(response.data);
          console.log(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }, []);
    console.log(project)
  
  
    const [budget, setbudget] = useState({ details: [] });
    const handleProjectSelection = async (p_id) => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`materailsCountdeatils.php?p_id=${p_id}&company_id=${company_id}`);
        console.log('API Response:', response.data);
        setbudget(response.data);
        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    console.log(budget);
  
  
    return (
      <>
  
        <div className="header bg-gradient-info py-7 py-lg-5 ">
        <div className="bg-gradient-info pb-8 pt-2 pt-md-8">
          <Container fluid>
            <div className="header-body">
            <div className="justify-content-end ">
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="mb-4 justify-content-end " >
              <DropdownToggle caret>
                Select Project
              </DropdownToggle>
              <DropdownMenu left>
              {Array.isArray(project) && project.length > 0 ? (
                                    project.map(project => (
                                        <DropdownItem key={project.p_id} onClick={() => handleProjectSelection(project.p_id)}>
                                            {project.p_name}
                                        </DropdownItem>
                                    ))
                                ) : (
                                    <p>No Project Yet?</p>
                                )}
            </DropdownMenu>
            </Dropdown>
            <span>Select project to view budget details</span>
            </div>
              {/* Card stats */}
              <Row>
                <Col lg="6" xl="4">
                  <Card className="card-stats mb-4 mb-xl-3">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Total Budget
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {budget.p_budget}
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                            <i className="fa-solid fa-dollar-sign" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm">
                        <span className="text-success mr-2">
                          <i className="fa fa-arrow-up" /> 100%
                        </span>{" "}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="4">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Drained Amount
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">{budget.spent}</span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="fas fa-hand-holding-dollar" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm">
                        <span className="text-danger mr-2">
                          <i className="fas fa-arrow-down" /> {budget.speper} %
                        </span>{" "}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="4">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Remaning Amount
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">{budget.remaining}</span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                            <i className="fas fa-file-invoice-dollar" />
                          </div>
                        </Col>
                      </Row>
                      <p className="mt-3 mb-0 text-muted text-sm">
                        <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> {budget.remper} %
                        </span>{" "}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
               
              </Row>
            </div>
          </Container>
        </div> 
          {/* Page content */}
          <Container className="mt--7 " fluid>
          <Row className="mt-2">
              <Col className="mb-5 mb-5" xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Material Details</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Material Name</th>
                      <th scope="col">Amount Spent</th>
                      <th scope="col">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                  {budget.details ? (
                      budget.details.map((material, index) => (
                          <tr key={index}>
                              <td>{material.mat_name}</td>
                              <td>{material.mat_money}</td>
                              <td>{material.mat_quantity}</td>
                          </tr>
                      ))
                  ) : (
                      <tr>
                          <td center colSpan="3">No details available, Project not yet started</td>
                      </tr>
                  )}
  
  
                  </tbody>
                </Table>
              </Card>
            </Col>
            </Row>
            <Row className="mt-5">
  
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">Projects</h3>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Project</th>
                        <th scope="col">Budget</th>
                        <th scope="col">Status</th>
                        <th scope="col">Users</th>
                        <th scope="col">Completion</th>
                      </tr>
                    </thead>
                    <tbody>
                    {project.map(project => (
                        <tr>
                        <th scope="row">
                          <Media className="align-items-center">
                            {/* <a
                              className="avatar rounded-circle mr-3"
                              href="#pablo"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                src={require("../../assets/img/theme/bootstrap.jpg")}
                              />
                            </a> */}
                            <Media>
                              <span className="mb-0 text-sm">
                                {project.p_name}
                              </span>
                            </Media>
                          </Media>
                        </th>
                        <td>{project.p_budget}</td>
                        <td className="projectstatus">
                          <Badge style={{backgroundColor:'green', color:'white'}} className="badge-dot mr-4 p-2">
                            {/* <i className="bg-warning" /> */}
                            {project.p_status}
                          </Badge>
                        </td>
                        <td>
                          <div className="avatar-group">
                            <a
                              className="avatar avatar-sm"
                              href="#pablo"
                              id="tooltip742438047"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                className="rounded-circle"
                                src={require("../../assets/img/theme/team-1-800x800.jpg")}
                              />
                            </a>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip742438047"
                            >
                              Ryan Tompson
                            </UncontrolledTooltip>
                            <a
                              className="avatar avatar-sm"
                              href="#pablo"
                              id="tooltip941738690"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                className="rounded-circle"
                                src={require("../../assets/img/theme/team-2-800x800.jpg")}
                              />
                            </a>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip941738690"
                            >
                              Romina Hadid
                            </UncontrolledTooltip>
                            <a
                              className="avatar avatar-sm"
                              href="#pablo"
                              id="tooltip804044742"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                className="rounded-circle"
                                src={require("../../assets/img/theme/team-3-800x800.jpg")}
                              />
                            </a>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip804044742"
                            >
                              Alexander Smith
                            </UncontrolledTooltip>
                            <a
                              className="avatar avatar-sm"
                              href="#pablo"
                              id="tooltip996637554"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                className="rounded-circle"
                                src={require("../../assets/img/theme/team-4-800x800.jpg")}
                              />
                            </a>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip996637554"
                            >
                              Jessica Doe
                            </UncontrolledTooltip>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <span className="mr-2">60%</span>
                            <div>
                              <Progress
                                max="100"
                                value="60"
                                barClassName="bg-danger"
                              />
                            </div>
                          </div>
                        </td>
                        
                      </tr>
                    ))}
                      
                      
                    </tbody>
                  </Table>
                </Card>
              </div>
            </Row>
          </Container>
        </div>
      </>
    );
  };

  export default Budget2;